<template>
  <b-form  class="restricted-token">
    <slot name="txtBefore"></slot>
    <b-row>
      <b-col>
        <div v-if="getRestrictedLoginChannel === 'EMAIL'">
          <p>
            <strong>E-Mail versendet</strong><br>
            Der Zugangscode wurde per E-Mail an {{ email }} versendet. Der Code ist bis {{ validUntil }} gültig.<br>
            <br>
            Die Zustellung der E-Mail kann mehrere Minuten dauern. Bitte prüfen sie Ihren E-Mail-Posteingang und den Spamordner.<br>
            <br>
            Um Ihre Kundendaten abrufen zu könne, geben Sie bitte Ihr Geburtsdatum an und klicken auf &bdquo;Weiter&ldquo;.
          </p>
        </div>
        <div v-if="getRestrictedLoginChannel === 'SMS'">
          <p>
            <strong>Zugangscode per SMS versendet</strong><br>
            Der Zugangscode wurde per SMS an die Rufnummer {{ msisdn }} versendet. Der Code ist bis {{ validUntil }} gültig.<br>
            <br>
            Um Ihre Kundendaten abrufen zu könne, geben Sie bitte Ihr Geburtsdatum an und klicken auf &bdquo;Weiter&ldquo;.
          </p>
        </div>
        <p>

        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div :id="'token_wrapper' + _uid" role="group" :class="{ 'form-group': true, 'error': isValid('token') === false, 'success': isValid('token') === true }">
          <label id="token__BV_label_" :for="'token' + _uid" :class="{ 'd-block customLabel': true, 'error': isValid('token') === false, 'success': isValid('token') === true }">
            <slot name="lblCode">Zugangscode <tooltip class="glyphicon glyphicon-question-sign">Bitte geben Sie den Zugangscode ein, den Sie von uns erhalten.</tooltip></slot>
          </label>
          <b-form-input
            :id="'token' + _uid"
            name="token"
            required
            v-model="token"
            data-msisdn
            type="text"
            @input="$v.token.$touch"
            :state="isValid('token')"
          ></b-form-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>Geburtsdatum</b-col>
    </b-row>
    <b-row>
      <b-col>
        <div :id="'day_wrapper' + _uid" role="group" :class="{
          'form-group': true,
            'error': isValid('year') === false || validDate === false,
            'success': isValid('year') ===  true && validDate !== false
        }">
          <label id="day__BV_label_" :for="'day' + _uid" :class="{
            'd-block customLabel': true,
            'error': isValid('day') === false || validDate === false,
            'success': isValid('day') ===  true && validDate !== false
          }"><slot name="lblDay">Tag</slot></label>
          <b-form-select
            :id="'day' + _uid"
            :options="days"
            name="day"
            required
            v-model="day"
            data-msisdn
            type="text"
            @input="$v.day.$touch"
            :state="isValid('day') && validDate !== false"
          ></b-form-select>
        </div>
      </b-col>
      <b-col>
        <div :id="'month_wrapper' + _uid" role="group" :class="{
          'form-group': true,
            'error': isValid('year') === false || validDate === false,
            'success': isValid('year') ===  true && validDate !== false
        }">
          <label id="month__BV_label_" :for="'month' + _uid" :class="{
            'd-block customLabel': true,
            'error': isValid('month') === false || validDate === false,
            'success': isValid('month') ===  true && validDate !== false
          }"><slot name="lblMonth">Monat</slot></label>
          <b-form-select
            :id="'month' + _uid"
            :options="months"
            name="month"
            required
            v-model="month"
            data-msisdn
            type="text"
            @input="$v.month.$touch"
            :state="isValid('month') && validDate !== false"
          ></b-form-select>
        </div>
      </b-col>
      <b-col>
        <div :id="'year_wrapper' + _uid" role="group" :class="{
          'form-group': true,
            'error': isValid('year') === false || validDate === false,
            'success': isValid('year') ===  true && validDate !== false
        }">
          <label id="year__BV_label_" :for="'year' + _uid" :class="{
            'd-block customLabel': true,
            'error': isValid('year') === false || validDate === false,
            'success': isValid('year') ===  true && validDate !== false
          }"><slot name="lblYear">Jahr</slot></label>
          <b-form-select
            :id="'year' + _uid"
            :options="years"
            name="year"
            required
            v-model="year"
            data-msisdn
            type="text"
            @input="$v.year.$touch"
            :state="isValid('year') && validDate !== false"
          ></b-form-select>
        </div>

      </b-col>
    </b-row>
    <slot name="txtAfter"></slot>
    <Stepper
      @prev="back()"
      variant-prev="tertiary"
      @next="next()"
      :disabled-next="$v.$invalid || loading"
      :loading-next="loading"
    >
      <template #btnNext><slot name="btnNext">weiter</slot></template>
    </Stepper>
  </b-form>
</template>

<script>

import Stepper from '@/components/generic/Stepper.vue'
import { BCol, BRow, BForm } from 'bootstrap-vue'
import processSteps from '@/mixins/processSteps'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import { required, minLength, maxLength, numeric, maxValue, minValue } from 'vuelidate/lib/validators'
import preFilledInput from '@/mixins/preFilledInput'
import { onLogin } from '@/apollo'
import Tooltip from '@/components/generic/Tooltip.vue'

const now = (new Date()).getTime()

export const stepName = 'queryToken'

export default {
  name: 'InputToken',
  components: { Stepper, BCol, BRow, BForm, Tooltip },
  data () {
    return {
      token: '',
      day: '',
      month: '',
      year: '',
      loading: false
    }
  },
  methods: {
    next () {
      if (this.$v.$invalid) {
        return
      }
      const component = this
      this.loading = true
      this.$store.dispatch('login', { msisdn: this.getRestrictedLoginMsisdn, token: this.token, birthdate: this.birthDate }).then(jwt => {
        // login for apollo client
        onLogin(component.$apolloProvider.defaultClient, jwt)

        document.querySelectorAll('.disableOnLogout').forEach((elm) => {
          elm.removeAttribute('disabled')
        })
        // login for cms
        const portalLoginForm = document.querySelector('form.mod_login')

        if (portalLoginForm) {
          portalLoginForm.querySelector('[name=username]').value = 'jwt'
          portalLoginForm.querySelector('[name=password]').value = jwt
          portalLoginForm.submit()

          // cannot reset state atm. will display first tab
          // this.reset()
        } else {
          this.loading = false
        }
      }, error => {
        if (error.response && error.response.data) {
          component.$store.commit('addError', error.response.data)
        } else if (error.message) {
          component.$store.commit('addError', { message: error.message })
        } else {
          component.$store.commit('addError', 'technical error!')
        }
        this.loading = false
      })
    },
    back () {
      this.changeStep({ step: this.previousStep })
    },
    ...mapActions({
      setChannel: 'setRestrictedLoginChannel',
      login: 'login',
      reset: 'reset'
    }),
    ...mapMutations({
      changeStep: 'changeRestrictedLoginStep'
    })
  },
  computed: {
    days () {
      const vals = []

      for (let i = 1; i <= 31; i++) {
        const val = ('0' + i).slice(-2)
        vals.push({ value: val, text: val })
      }
      return vals
    },
    months () {
      const vals = []

      for (let i = 1; i <= 12; i++) {
        const val = ('0' + i).slice(-2)
        vals.push({ value: val, text: val })
      }
      return vals
    },
    years () {
      const vals = []

      for (let i = (new Date()).getFullYear() - 16; i >= 1900; i--) {
        vals.push({ value: i, text: i })
      }
      return vals
    },
    birthDate () {
      return this.year + '-' + ('0' + this.month).slice(-2) + '-' + ('0' + this.day).slice(-2)
    },
    validDate () {
      if (this.year && this.month && this.day) {
        const date = new Date(this.year, this.month - 1, this.day)
        return date.getDate() === parseInt(this.day) &&
          (date.getMonth() + 1) === parseInt(this.month) &&
          date.getFullYear() === parseInt(this.year) &&
          date.getTime() < now
      } else {
        return null
      }
    },
    msisdn () {
      return this.getRestrictedLoginData.msisdn
    },
    email () {
      return this.getRestrictedLoginData.shortenedEmail
    },
    validUntil () {
      return this.$config.calendar.formatter.dateShortTimeFormatter.format(new Date(this.getRestrictedLoginData.expiration))
    },
    ...mapGetters([
      'getRestrictedLoginMsisdn',
      'getRestrictedLoginChannel',
      'getRestrictedLoginData'
    ])
  },
  mixins: [
    processSteps(stepName, stepName, stepName),
    validationMixin,
    isValid,
    preFilledInput('birthdate', 'getRestrictedLoginBirthdate')
  ],
  validations: {
    token: {
      required
    },
    day: {
      required,
      numeric,
      minValue: minValue(1),
      maxValue: maxValue(31)
    },
    month: {
      required,
      numeric,
      minValue: minValue(1),
      maxValue: maxValue(12)
    },
    year: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4)
    }
  }
}
</script>
